import { useStateValue } from 'context/store'
import { VALUES } from '../constants'

export function useGetUserSettings() {
   const [{ sessionUser = {} }] = useStateValue()
   const userSettings = sessionUser.settings || {}

   const isInternalUser = userSettings.type === VALUES.USER_TYPE.INTERNAL

   const isInternalSuperAdmin = userSettings.isSuperAdmin && isInternalUser

   const isInternalAdmin = userSettings.isAdmin && isInternalUser

   const userName =
      userSettings.documentType === 'NI'
         ? `${userSettings.entity?.name?.toLowerCase()}`
         : `${userSettings.name?.toLowerCase()} ${userSettings.lastName?.toLowerCase()}`

   const userEntity = userSettings.entity?.name || 'No registra Entidad'

   return { isInternalAdmin, userName, userEntity, isInternalSuperAdmin, isInternalUser }
}
